import BaseClass from "../BaseClass";

export class SocialiteLogin extends BaseClass {
    constructor(element) {
        super(element);

        this.loginUrl = null;
        this.redirectUrl = null;
        this.loginChannel = null;

        this.init();
    }

    init() {
        this.$window = $(window);
        this.loginUrl = this.$element.data('loginUrl');
        this.loginChannel = new BroadcastChannel('socialite_login');

        let redirectUrl = this.$element.data('redirectUrl');
        if (redirectUrl != undefined && redirectUrl.length > 0) {
            this.redirectUrl = this.$element.data('redirectUrl');
        }

        let mySelf = this;
        this.clickListener = function () {
            mySelf.openAuthWindow();
        };

        this.loginChannel.addEventListener('message', $.proxy(this.handleMessage, this));
        this.$element.on('click', $.proxy(this.clickListener, this));
    }

    handleMessage(event) {
        const eventData = event?.data?.ajaxRedirectResponse?.original;

        if (eventData && eventData.actions) {
            $(document).trigger('hide:loading');

            if (this.redirectUrl != null) {
                eventData.url = this.redirectUrl;
            }

            this.handleAjaxResponse(eventData);
        }
    }

    openAuthWindow() {
        this.authWindow = window.open(this.loginUrl, 'authWindow', 'width=800, height=600');
    }

    destroyListener() {
        this.$element.off('click', $.proxy(this.clickListener, this));
        this.loginChannel.removeEventListener('message', $.proxy(this.handleMessage, this));
        this.loginChannel.close();
    }
}